import { getCurrentTimeInMs, ONE_DAY_IN_MS } from "@/lib/utils";
import { isRelativeDate } from "../isRelativeDate";

export const convertToRelativeDateInDays = (val?: string): string => {
	if (!val) return "";

	const now = getCurrentTimeInMs();

	if (isRelativeDate(val))
		return String(Math.round(Number(val) / ONE_DAY_IN_MS));
	return String(Math.round((Number(val) - now) / ONE_DAY_IN_MS));
};
